import { Component, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { MainService } from 'src/app/services/main.service';
import { DatePipe } from '@angular/common';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';
import { ListReportComponent } from '../list-report/list-report.component';
import { DialogService as DS } from '../../../shared/components/dialog/index';

export interface PopUpModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-loyalty',
  templateUrl: './loyalty.component.html',
  styleUrls: ['./loyalty.component.css']
})

export class LoyaltyComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  data: any;
  result: any = { result: false, RtnItem: {} };
  model: any = { CardNo: '' };
  new_data = new Date();
  Nations_List: any = [];
  Nation = '';
  Card: any;
  PreDisc_List: any = [];
  settings: any;
  selected_tab = 'Profile';
  tab_index = 0;

  constructor(public dialogService: DialogService, private ps: PosService, private dp: DatePipe,
    private ms: MainService, private dS: DS) {
    super(dialogService);
  }

  ngOnInit() {
    this.Card = this.data.CardNo;
    this.clear();
    if (this.data.CardNo) {
      this.get_MemberByCardNo_POS(this.Card);
    }
  }

  get_MemberByCardNo_POS(Card) {
    const a: any = {
      Code: Card
    };
    this.ps.Get_MemberByCardNo_POS(a).subscribe(res => {
      if (res.Success) {
        this.model = res.data;
        this.model.DOB = this.dp.transform(this.model.DOB, 'yyyy-MM-dd')
        this.Nation = this.model.Nationality;
      } else {
        const msg = confirm('Profile Details Not found.!\nDo you want to create ?');
        if (msg) {
          this.tab_index = 1;
          this.model.CardNo = Card;
        }
        this.clear();
      }
    });
  }

  keyDown(e, model) {
    if (e.keyCode === 13) {
      if (model === 'CardNo') {
        this.get_MemberByCardNo_POS(this.Card);
      }
    }
  }

  clear() {
    this.settings = this.ms.getSettings();
    this.model = {
      MemberId: 0,
      Name: '',
      Address: '',
      DOB: this.dp.transform(this.new_data, 'yyyy-MM-dd'),
      Gender: '',
      Nationality: '',
      NationalityId: 0,
      Mobile: '',
      OpeningBalance: 0,
      JoingDate: this.dp.transform(this.new_data, 'yyyy-MM-dd'),
      Email: '',
      POBox: '',
      Balance: 0,
      CardNo: '',
      PredefinedDiscId: 0,
      PredefinedDiscName: '',
      LocId: this.settings.LocId
    };
    this.Load_Nation();
    this.loadPredefinedDiscount();
    this.model.LocId = this.settings.LocId;
    document.getElementById('card').focus();
  }

  Load_Nation() {
    this.ps.Get_Nationality().subscribe(res => {
      if (res.Success) {
        this.Nations_List = res.data;
        if (this.Nations_List.length !== 0) {
          this.model.NationalityId = this.Nations_List[0].Id;
        }
      }
    });
  }

  btn_update() {
    this.model.LocId = this.settings.LocId;
    this.ps.POS_Update_Member(this.model).subscribe(res => {
      if (res.Success) {
        this.model = res.data;
        this.Nation = this.model.Nationality;
        this.get_MemberByCardNo_POS(res.data.CardNo);
        this.tab_index = 0;
        alert('Profile Created Successful ');
      }
      else {
        alert(res.error.UserMsg)
      }
    });
  }

  btn_ok() {
    if (this.model.MemberId !== 0) {
      this.result.result = true;
      this.result.RtnItem = this.model;
      this.close();
    }
  }

  card_Gen(e) {
    if (e == 1) {
      this.ps.POS_Generate_CardNo().subscribe(res => {
        if (res.Success) {
          this.model.CardNo = res.data;
        }
      });
    }
    if (e == 2) {
      if (this.model.Mobile == "") {
        alert("Please enter Mobile Number")
      }
      else {
        this.model.CardNo = this.model.Mobile
      }
    }
  }

  loadPredefinedDiscount() {
    const locationId: any = {
      Id: this.settings.LocId
    };

    this.ps.GetPredefinedDiscount(locationId).subscribe(res => {
      if (res.Success) {
        this.PreDisc_List = res.data;
        if (this.PreDisc_List.length !== 0) {
          this.model.PredefinedDiscId = this.PreDisc_List[0].Id;
        }
      }
    });
  }

  history() {
    let data = {
      CardNo: this.model.CardNo,
      MemberId: 0,
      Filter: {
        Start: 0,
        Limit: 10000,
        LocationId: this.settings.LocId
      }
    };
    this.ps.PredefinedHistory(data).subscribe(res => {
      if (res.Success) {
        const cols = [
          { field: 'InvNo', header: 'InvNo', f: 'text' },
          { field: 'InvDate', header: 'Inv Date', f: 'date' },
          { field: 'Total', header: 'Total', f: 'decimal' },
          { field: 'Discount', header: 'Discount', f: 'decimal' }
        ];
        const rows = res.data;
        const r = { cols: cols, rows: rows };
        this.dS.addDialog(ListReportComponent, { title: "BILL HISTORY", Item: r }).subscribe((res) => { });
      }
    });
  }

}
